import axios from "axios";
import moment, { duration } from "moment";
import { Chip } from "primereact/chip";
import { Card } from 'primereact/card';

class UtilitiesService {
  show() {
  }

  TimelineView = (item) => {
    const capitalizeFirstLetter = (str) => str.replace(/\b\w/g, (char) => char.toUpperCase());
    const userName = `${capitalizeFirstLetter(item.pm.firstName)} ${capitalizeFirstLetter(item.pm.lastName)}`;
    const commentColor = (item.statusValue === 3 || item.statusValue === 5 || item.statusValue === 7) ? '#ff0000' : 'indigo';
    return (
      <Card title={item.status} className='timeline-details' style={{ width: '400px', marginTop: '5px', backgroundColor: '#DCDCDC' }}>
        <div>
          {item.statusValue === 1 && 'Created By : '}
          {(item.statusValue === 2 || item.statusValue === 4 || item.statusValue === 6 || item.statusValue === 9) && 'Approved By : '}
          {(item.statusValue === 3 || item.statusValue === 5 || item.statusValue === 7) && 'Rejected By : '}
          {userName}
        </div>
        <div style={{ marginLeft: '250px', marginTop: '-16px', marginBottom: '-1px', wordWrap: 'break-word' }}><b>{item.date}</b></div>
        <div style={{ marginLeft: '0px', marginTop: '16px', maxWidth: '300px', overflowWrap: 'break-word' }}>
          {(item.statusValue === 2 || item.statusValue === 3 || item.statusValue === 4 || item.statusValue === 5 || item.statusValue === 6 || item.statusValue === 7) &&
            <b>Comment : </b>
          }
          <span style={{ color: commentColor }}>{item.statusValue !== 9 ? item.comment : ''}</span>
        </div>
      </Card>
    );
  };

  expenseActivityData = (e, events, item) => {
    const categoryStatus = this.getCategoryStatus(item);
    const eventMapping = {
      1: 'Claim Submitted',
      2: `Approved By RO`,
      3: `Rejected By RO`,
      4: `Approved By ${categoryStatus}`,
      5: `Rejected By ${categoryStatus}`,
      6: 'Approved By Finance Manager',
      7: 'Rejected By Finance Manager',
      9: 'Clearance Done'
    };

    const eventData = {
      status: eventMapping[e.status],
      statusValue: e.status,
      date: moment(e?.createdAt).format('YYYY-MM-DD HH:mm'),
      pm: e.pm,
      comment: e.comment,
      icon: e.status === 9 ? 'pi pi-check' : `pi pi-${[1, 2, 4, 6].includes(e.status) ? 'check' : 'times'}`,
      color: [3, 5, 7].includes(e.status) ? '#FFcccb' : '#607D8B'
    };
    events.push(eventData);
    events.sort((a, b) => a.statusValue - b.statusValue);
  };

  renderClaimAmount = (rowData) => {
    const currency = rowData?.currency
    return (
      <>
        {currency} {rowData?.claimAmount}
      </>
    );
  };

  getCategoryStatus(expenseCategory) {
    if (expenseCategory == 'Visa') return "TRAVEL DESK";
    else if (expenseCategory == 'Training and Certifications') return "HR";
    else if (expenseCategory == 'Transport') return "ADMIN";
    else return expenseCategory;
  }

  fetchStatus = (status, expenseCategory) => {
    if (status === 1) return (<div style={{ color: "orange" }}>AWAITING RO APPROVAL</div>);
    if (status === 2) return (<div style={{ color: "green" }}>AWAITING {this.getCategoryStatus(expenseCategory)} APPROVAL</div>)
    if (status === 3) return (<div style={{ color: "red" }}>REJECTED BY RO</div>);
    if (status === 4) return (<div style={{ color: "green" }}>AWAITING FINANCE APPROVAL</div>)
    if (status === 5) return (<div style={{ color: "red" }}>REJECTED BY {this.getCategoryStatus(expenseCategory)}</div>)
    if (status === 6) return (<div style={{ color: "green" }}>AWAITING CLEARANCE</div>)
    if (status === 7) return (<div style={{ color: "red" }}>REJECTED BY FINANCE </div>)
    if (status === 8) return (<div style={{ color: "red" }}>DELETED</div>)
    if (status === 9) return (<div style={{ color: "#673AB7" }}>CLAIM PROCESSED</div>);
    if (status === 10) return (<div style={{ color: "purple" }}>AWAITING MANAGER APPROVAL</div>)
  };

  userProjects = (rowData) => {
    if (Array.isArray(rowData.project) && rowData.project.length > 0) {
      const projects = rowData.project.map(project => project.projectName).join(', ');
      const userProjectsData = projects.match(/.{1,50}/g) || [];
      return (
        <span>
          {userProjectsData.map((userProjectName, index) => (
            <div key={index} style={{ display: 'flex', marginBottom: '8px' }}>
              <span>{userProjectName}</span>
            </div>
          ))}
        </span>
      );
    } else {
      return <span>N/A</span>;
    }
  }

  fullNameBody = (rowData) => {
    return <p>{rowData.firstName + " " + rowData.lastName}</p>
  }

  initialCapital(str, startWithCapital = false, speceSeprator = false) {
    let text = str.replace(/ /g, "_");
    let words = text.split("_");
    let items = [];
    words.map((item) => {
      let newWord = item.toLowerCase();
      newWord = newWord.charAt(0).toUpperCase() + newWord.slice(1);
      items.push(newWord);
    });
    let result = items.join(speceSeprator ? " " : "");
    return startWithCapital
      ? result.charAt(0).toUpperCase() + result.slice(1)
      : result.charAt(0).toLowerCase() + result.slice(1);
  }

  key2Label(str, underscoreSeprator = false) {
    var result = str.replace(/([A-Z])/g, " $1");
    let words = result.split(" ");
    let newArray = [];
    words.map((x) => {
      newArray.push(x.charAt(0).toUpperCase() + x.slice(1));
    });
    return underscoreSeprator
      ? newArray.join("_").toLowerCase()
      : newArray.join(" ");
  }

  getQueryVariable = (variable) => {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] === variable) {
        return pair[1];
      }
    }
    return false;
  };

  /* to use prevent whitespace at the start of char/int */
  charIntWhithoutSpace = (e) => {
    const re = e.charCode;
    if (re === 32 && e.target.value == 0) {
      e.preventDefault();
    }
  };
  /* to use prevent whitespace at the start of char/int */

  /* to use prevent char only */
  preventChar = (e) => {
    const re = e.charCode;
    if (re > 57 || re === 32) {
      e.preventDefault();
    }
  };
  /* to use prevent char only */

  /* User First name last Name Merge */
  titleCase = (str = "") => {
    let words = str.split(" ");
    words.forEach((w, i) => {
      w = w.substring(0, 1).toLocaleUpperCase() + w.substring(1);
      words[i] = w;
    });
    return words.join(" ");
  };
  /* User First name last Name Merge */

  /* to prevent char and minus on input box */
  preventCharWithMinus = (e) => {
    const re = e.charCode;
    if (e.code === "Minus" || re > 57 || re === 32) {
      e.preventDefault();
    }
  };
  /* to prevent char and minus on input box */

  /* to prevent paste char on input box only */
  preventPasteChar = (event) => {
    if (event.type == "paste") {
      var clipboardData = event.clipboardData || window.clipboardData;
      var pastedData = clipboardData.getData("Text");
      if (isNaN(pastedData)) {
        event.preventDefault();
      } else {
        return;
      }
    }
  };
  /* to prevent paste char on input box only */

  /* to prevent int with minus on input box only */
  preventIntWithMinusWhiteSpace = (e) => {
    const re = e.charCode;
    var keyCode = e.keyCode ? e.keyCode : e.which;
    if (
      e.code === "Minus" ||
      (keyCode > 47 && keyCode < 58) ||
      (re === 32 && e.target.value == 0)
    ) {
      e.preventDefault();
    }
  };
  /* to prevent int with minus on input box only */

  /* to prevent minus only */
  preventMinus = (e) => {
    const re = e.charCode;
    if (e.code === "Minus" || re > 57 || re === 32) {
      e.preventDefault();
    }
  };

  preventMorethan8 = (e) => {
    if (e.value > 8) {
      e.preventDefault();
    }
  };

  /* for change date format start */
  dateTimestampConverter = (str) => {
    let myDate = new Date(str.split("-"));
    let newDate = new Date(myDate[2], myDate[1] - 1, myDate[0]);
    return newDate;
  };

  dateConverter = (str) => {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    var year = date.getFullYear();
    return `${day}-${mnth}-${year}`;
  };
  dateWithMonthConverter = (str) => {
    if(str === null || str === undefined) return '';
    const date = new Date(str)
    const result = moment(date).format('DD-MM-YYYY')
    return `${result !== 'Invalid date' ? result : ''}`;
  };

  dateParser = (str, format = 'DD-MM-YYYY ddd') => {
    const date = new Date(str)
    const result = moment(date).format(format)
    return `${result === 'Invalid date' || str === null ? '-' : result}`;
  }

  invoiceDateConverter = (str) => {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2);
    var years = date.getFullYear();
    const sDate = `01-${mnth}-${years}`;

    const [day, month, year] = sDate.split('-').map(num => parseInt(num, 10));
    const nextMonthDate = new Date(year, month, 0);
    const lastDate = nextMonthDate.getDate().toString().padStart(2, '0') + '-' +
      (nextMonthDate.getMonth() + 1).toString().padStart(2, '0') + '-' +
      nextMonthDate.getFullYear();
    // return `01-${mnth}-${year}`;

    return sDate + '/' + lastDate;
  };

  changeFormatInDayYear = (invoiceSDate) => {
    let dateObj = new Date(invoiceSDate.split('-').reverse().join('-'));
    // Format the date as "Month-Year"
    let options = { year: 'numeric', month: 'long' };
    return dateObj.toLocaleDateString('en-US', options);
  };

  /* for change date format May 01, 2023 */
  dateConverterUS = (str, time = false) => {
    if (time) {
      return moment(str).format("MMM DD, YYYY [at] hh:mm A");
    } else {
      return moment(str).format("MMM DD, YYYY");
    }
  };

  /* for change date format 01-Jun-2023 */
  dateConverterShort = (str) => {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    var year = date.getFullYear();
    const dateStart = new Date(year, mnth - 1, day); // 2009-11-10
    const monthName = dateStart.toLocaleString("default", {
      month: "short",
    });
    return `${day}-${monthName}-${year}`;
  };

  dateConverterForAttendance = (str) => {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    var year = date.getFullYear();
    return `${year}-${mnth}-${day}`;
  };

  //convert Tue Jan 16 2024 00:00:00 GMT+0530 (India Standard Time) to 2024-01-16
  dateConverterForLeave = (str) => {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    var year = date.getFullYear();
    return `${year}-${mnth}-${day}`;
  };


  changeAttendanceDateFormat = (str) => {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    var hours = ("0" + date.getHours()).slice(-2);
    var minutes = ("0" + date.getMinutes()).slice(-2);
    var seconds = ("0" + date.getSeconds()).slice(-2);
    var year = date.getFullYear();
    return `${year}-${mnth}-${day} ${hours}:${minutes}:${seconds}`
  };


  changeAttendanceDateFormatToCurrentTimeZone = (date, time) => {
    const currTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const utcDateTime = date + " " + time + '+0000';
    const localDateTime = new Date((typeof utcDateTime === "string" ? new Date(utcDateTime) : utcDateTime).toLocaleString("en-US", { timeZone: currTimeZone }));
    const localDateTimeInOutDateTime = this.changeAttendanceDateFormat(localDateTime);
    return localDateTimeInOutDateTime;
  }

  getTimeFromDate = (str) => {
    let hours = (str.getHours() > 9) ? str.getHours() : "0" + str.getHours();
    let minutes = (str.getMinutes() > 9) ? str.getMinutes() : "0" + str.getMinutes();
    let seconds = (str.getSeconds() > 9) ? str.getSeconds() : "0" + str.getSeconds();
    let time = hours + ":" + minutes + ":" + seconds;
    return time;
  };
  /* for change date format end */

  /* for change date format start */
  dateConverterToMonthDay = (str) => {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    var year = date.getFullYear();
    return `${mnth}-${day}-${year}`;
  };
  /* for change date format end */

  /* for change date into short format start */
  dateConvertToShort = (str) => {
    const day = str.toLocaleString().split("-")[0];
    const month = str.toLocaleString().split("-")[1];
    const year = str.toLocaleString().split("-")[2];
    const dateStart = new Date(year, month - 1, day); // 2009-11-10
    const monthName = dateStart.toLocaleString("default", {
      month: "short",
    });
    return `${day}-${monthName}-${year}`;
  };
  /* for change date into short format end */

  /* for current monday week start */
  getMondayOfCurrentWeek = (urlAction, urlDate) => {
    if (urlAction === 'dashboard') {
      const urlDateArr = urlDate.split("-");
      const formattedDateArr = urlDateArr[1] + "-" + urlDateArr[0] + "-" + urlDateArr[2];
      return new Date(formattedDateArr);
    } else {
      const today = new Date();
      const first = today.getDate() - today.getDay() + 1;
      const monday = new Date(today.setDate(first));
      return monday;
    }
  };
  /* for current monday week end */

  /* Add Days into date */
  addDays = (date, days) => {
    const dateCopy = new Date(date);
    dateCopy.setDate(date.getDate() + (days - 1));
    return dateCopy;
  };

  /* Past Days into date */
  pastDays = (date, days) => {
    const dateCopy = new Date(date);
    dateCopy.setDate(date.getDate() - (days - 1));
    return this.dateConverter(dateCopy);
  };
  /* Past Days into date */

  /* get days from month */
  getDaysInMonth = (month, year) => {
    return new Date(year, month + 1, 0).getDate();
  }
  /* get days from month */
  /* Add Days into date */

  convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  /*To export a file in Excel*/

  exportExcel(data, fileName) {
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(data);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, fileName);
    });
  }

  saveAsExcelFile(buffer, fileName) {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });

        module.default.saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
        );
      }
    });
  }

  /*To export a file in Excel*/

  /*Export a file in PDF */
  exportPdf = (columns, data, fileName) => {
    var invoiceListing = [];
    data.map((item) => {
      let objInvoice = {
        ecn: item.ecn,
        name: this.invoiceBodyTemplate(item, "name"),
        designation: this.invoiceBodyTemplate(item, "designation"),
        bu: this.invoiceBodyTemplate(item, "bu"),
        client: this.invoiceBodyTemplate(item, "client"),
        projectCode: this.invoiceBodyTemplate(item, "projectCode"),
        projects: this.invoiceBodyTemplate(item, "project"),
        projectType: this.invoiceBodyTemplate(item, "projectType"),
        totalDays: this.invoiceBodyTemplate(item, "totalDays"),
        otHours: this.invoiceBodyTemplate(item, "otHours"),
        hours: this.invoiceBodyTemplate(item, "hours"),
        totalHours: this.invoiceBodyTemplate(item, "totalHours"),
        pm: this.invoiceBodyTemplate(item, "pm"),
        status: this.invoiceBodyTemplate(item, "status"),
      };
      invoiceListing.push(objInvoice);
    });

    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        // const doc = new jsPDF.default(0, 0);
        const doc = new jsPDF.default("portrait", "pt", "a4");
        doc.autoTable(columns, invoiceListing);
        doc.save(fileName + ".pdf");
      });
    });
  };
  /*Export a file in PDF */

  /*Export a file in PDF for setting*/

  exportAsPdf = (columns, data, fileName) => {
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        const doc = new jsPDF.default(0, 0);

        doc.autoTable(columns, data);

        doc.save(fileName + ".pdf");
      });
    });
  };

  /*Export a file in PDF for setting*/

  /* Export CSV Start */
  exportToCSV = (params) => {
    try {
      const mapItems = [...params.bodyData];
      // Sort Columns
      const sortedColumns = params.headersKey.concat(
        Object.keys(mapItems[0]).filter(
          (k) => k !== params.headersKey[0] && k !== params.headersKey[1]
        )
      );
      // Create new applicants in correct column order
      const newOrder = mapItems.map((a) => {
        let row = {};
        sortedColumns.forEach((c) => (row[c] = a[c]));
        return row;
      });
      let csvRow = [];
      let A = [];
      // Header
      A.push(["", ...params.headers]);
      // Body
      newOrder.forEach((e) => {
        let rowItem = [];
        Object.keys(e).forEach((key) => {
          if (params.headersKey.includes(key)) {
            rowItem.push(e[key]);
          }
        });
        A.push(rowItem);
      });
      let j = 0;
      A.forEach((e) => {
        csvRow.push(A[j].join(","));
        j++;
      });
      const csvString = csvRow.join("%0A");
      let doc2 = document.createElement("a");
      doc2.href = "data:text/csv;charset=utf-8" + csvString;
      doc2.target = "_Blank";
      doc2.download = params.fileName + ".csv";
      document.body.appendChild(doc2);
      doc2.click();
    } catch (error) { }
  };
  /* Export CSV End */

  invoiceBodyTemplate = (rowData, type) => {
    switch (type) {
      case "name":
        return rowData.firstName + " " + rowData.lastName;
      case "designation":
        return rowData.Designation.title;
      case "region":
        return rowData.Timesheets[0]?.timesheetProjects[0]?.projectDetails
          ?.customers?.code;
      case "bu":
        return rowData.Timesheets[0]?.timesheetProjects[0]?.projectDetails
          ?.businessUnits?.title;
      case "client":
        return rowData.Timesheets[0]?.timesheetProjects[0]?.projectDetails
          ?.customers?.title;
      case "projectCode":
        return rowData.Timesheets[0]?.timesheetProjects[0]?.projectDetails
          ?.code;
      case "projectType":
        return rowData.Timesheets[0]?.timesheetProjects[0]?.projectDetails
          ?.projectTypes?.title;
      case "pm":
        return (
          rowData.Timesheets[0]?.timesheetProjects[0]?.projectDetails?.pmDetails
            ?.firstName +
          " " +
          rowData.Timesheets[0]?.timesheetProjects[0]?.projectDetails?.pmDetails
            ?.lastName
        );
      case "project":
        let proName = [];
        rowData.Timesheets.map((el) => {
          el.timesheetProjects.map((e) => {
            proName.push(e.projectDetails.title);
          });
        });
        let proNameUnique = Array.from(new Set(proName));
        return proNameUnique.join("; ");
      case "status":
        const invoiceStatus = rowData.Timesheets.map((el) => {
          return el.status;
        });
        return invoiceStatus.includes("APPROVED") ? "UNLOCK" : "LOCK";
      case "totalDays":
        return rowData.Timesheets.length;
      case "hours":
        return (
          <div style={{ marginLeft: "15px" }}>
            <strong>{rowData.Timesheets[0].totalHours}</strong>
          </div>
        );
      case "totalHours":
        let total = 0;
        for (let i = 0; i < rowData.Timesheets.length; i++) {
          total += rowData.Timesheets[i].totalHours
            ? rowData.Timesheets[i].totalHours
            : 0;
        }
        return total;
      default:
        return "";
    }
  };

  activityItemBody = (el) => {
    return (
      <div>
        {" "}
        <span>{el.title}</span>
        {el.isBillable ? (
          <span
            style={{
              // marginLeft: "20px",
              height: "14px",
              color: "green",
              fontSize: "10px",
            }}
          >&nbsp;(Billable)</span>
        ) : (
          <span
            style={{
              // marginLeft: "20px",
              height: "14px",
              color: "red",
              fontSize: "10px",
            }}
          >&nbsp;(Non-Billable)</span>
        )}
      </div>
    );
  };

  /*GET IP and Location Start */
  generateIp = async () => {
    // const res = await axios.get('https://geolocation-db.com/json/');
    const response = await fetch(`https://geolocation-db.com/json/`);
    const data = await response.json();
    return data;
  };
  /*GET IP and Location End */

  validURL(str) {
    var pattern = new RegExp(
      "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$",
      "i"
    ); // fragment locator
    return !!pattern.test(str);
  }

  currentTimeInUtc() {
    const now = new Date();
    const year = now.getUTCFullYear();
    const month = now.getUTCMonth() + 1;
    const day = now.getUTCDate();
    const hours = now.getUTCHours();
    const minutes = now.getUTCMinutes();
    const seconds = now.getUTCSeconds();
    const milliseconds = now.getUTCMilliseconds();

    let nowINUTC = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
    return nowINUTC;
  }


  convertTZ(date, time = '00:00:00.000Z') {
    const tzString = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const utcDateTime = date + " " + time;
    return new Date((typeof utcDateTime === "string" ? new Date(utcDateTime) : utcDateTime).toLocaleString("en-US", { timeZone: tzString }));
  }

  getTimeWithTimezone = (str) => {
    return str.toString().slice(16);
  };


  inTimeTemplate = (rowData) => {
    if (rowData.inTime) {
      const date = moment(rowData.inTime);
      return <p>{date.format('DD-MM-YYYY HH:mm')}</p>;
    }
  };

  outTimeTemplate = (rowData) => {
    if (rowData.outTime) {
      const date = moment(rowData.outTime);
      return <p>{date.format('DD-MM-YYYY HH:mm')}</p>;
    }
  };

  empOutTimeTemplate = (rowData) => {
    if (rowData.outTime) {
      const date = moment(rowData.outTime);
      return <p>{date.format('DD-MM-YYYY HH:mm:ss')}</p>;
    }
  };

  attendanceTimeDiff = function (endTime, startTime) {
    var timeDiff = (endTime.getTime() - startTime.getTime()) / 1000;
    timeDiff /= 60;
    if (timeDiff < 0) {
      return -1;
    } else {
      return Math.abs(Math.round(timeDiff));
    }
  };

  projectBodyTemplate = (rowData) => {
    let proName = [];
    rowData.timesheetProjects?.map((e) => {
      proName.push(e?.projectDetails?.title);
    });
    let proNameUnique = proName?.filter((item, index) => proName?.indexOf(item) === index);
    let proNameS = [];
    for (let p of proNameUnique) {
      proNameS.push(
        <Chip label={p} className="mr-2 mb-1 mt-1" />
      );
    }
    return <span className="">{proNameS}</span>;
  }


  workingHoursDff = (data) => {
    var startTime = new Date(data.inTime);
    const currentDate = new Date();
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const dateInTimeZone = new Date(currentDate.toLocaleString('en-US', { timeZone: timeZone }));
    var endTime = new Date(data.outTime ? data.outTime : dateInTimeZone);
    var totalWorkingHourDiff = this.attendanceTimeDiff(endTime, startTime);
    var timeCaptureInAttToolInHr = Math.floor(totalWorkingHourDiff / 60);
    var timeCaptureInAttTool = timeCaptureInAttToolInHr.toString().padStart(2, '0') + ":" + (totalWorkingHourDiff % 60).toString().padStart(2, '0');
    return timeCaptureInAttTool;
  }


  attendanceHrdDiff = (startTime, endTime) => {
    var totalWorkingHourDiff = this.attendanceTimeDiff(endTime, startTime);
    var timeCaptureInAttToolInHr = Math.floor(totalWorkingHourDiff / 60);
    var timeCaptureInAttTool = timeCaptureInAttToolInHr.toString().padStart(2, '0') + ":" + (totalWorkingHourDiff % 60).toString().padStart(2, '0');
    return timeCaptureInAttTool;
  }

  convertHoursIntoMin = (hrs) => {
    const hrsSplit = hrs.split(":");
    if (hrsSplit[0] < 0 || hrsSplit[1] < 0) {
      return -1;
    } else {
      const totalMinutes = parseInt(hrsSplit[0]) * 60 + parseInt(hrsSplit[1]);
      return totalMinutes;
    }
  }

  /* Show Created Date on Draft Timesheet */
  timesheetCreatedDate = (rowData, format = 'DD-MM-YYYY') => {
    var inDateTime = rowData.createdAt.split("T");
    inDateTime = this.convertTZ(inDateTime, "");
    inDateTime = moment(inDateTime).format('DD-MM-YYYY');
    return <p>{inDateTime}</p>;
  };
  /* Show Created Date on Draft Timesheet */
  timesheetFormatedDate = (rowData, options, format = 'DD-MM-YYYY') => {
    const v = rowData[options.field] || '';
    var inDateTime = v?.split("T");
    inDateTime = this.convertTZ(inDateTime, "");
    inDateTime = moment(inDateTime).format(format);
    return <p>{inDateTime}</p>;
  };

  /* Show Milestone Updated Date */
  milestoneUpdatedDate = (rowData) => {
    var inDateTime = rowData.updatedAt.split("T");
    inDateTime = this.convertTZ(inDateTime, "");
    inDateTime = moment(inDateTime).format('DD-MM-YYYY HH:mm:ss');
    return <p>{inDateTime}</p>;
  };
  /* Show Milestone Updated Date */
  percentageUpdatedDate = (rowData) => {
    var percentageDate = rowData.createdAt.split("T");
    percentageDate = this.convertTZ(percentageDate, "");
    percentageDate = moment(percentageDate).format('DD-MM-YYYY HH:mm:ss');
    return <p>{percentageDate}</p>;
  };
  /*converting html tags to plain text */
  removeHtmlTags = (input) => {
    return input?.replace(/<\/?[^>]+(>|$)/g, "");
  }
  /*Training status */
  getTrainingStatus = (statusCode) => {
    let status;
    switch (statusCode) {
      case 0:
        status = 'DRAFT';
        break;
      case 1:
        status = 'SUBMITTED TO MANAGER';
        break;
      case 2:
        status = 'APPROVED BY MANAGER';
        break;
      case 3:
        status = 'REJECTED BY MANAGER';
        break;
        case 4:
        status = 'SUBMITED TO TRAINING MANAGER';
        break;
        case 5:
        status = 'APPROVED BY TRAINING MANAGER';
        break;
        case 6:
        status = 'REJECTED BY TRAINING MANAGER';
        break;
      default:
        status = 'UNKNOWN'; // Default case if the statusCode doesn't match any cases
        break;
    }
    return status;
  };


  /*Training status */
  getUserTrainingStatus = (statusCode) => {
    let status;
    switch (statusCode) {
      case 0:
        status = 'TODO';
        break;
      case 1:
        status = 'In Progress';
        break;
      case 2:
        status = 'Attended';
        break;
      case 3:
        status = 'Completed';
        break;
      default:
        status = 'UNKNOWN'; // Default case if the statusCode doesn't match any cases
        break;
    }
    return status;
  };

}



export default UtilitiesService;
const utitService = new UtilitiesService();
export { utitService }